module.exports = __webpack_public_path__ + "assets/img/2.b2a1cc0d.png";